import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import Swiper from "react-id-swiper";
import TestimonialTwoSingle from "../../components/testimonial/TestimonialTwoSingle.js";
import { AuthContext } from "../../common/Auth"
import TestimonialImageEditIcon from "../../pages/testimonial/testimonialImage/TestimonialImageEditIcon"

const TestimonialTwo = () => {
  // swiper slider settings
  const { testimonialList, themeSettingsData } = useContext(AuthContext)
  const [testimonialId, setTestimonialId] = useState("");
  const [bgImage, setBgImage] = useState("");
  const [bgColor, setBgColor] = useState("bg-gray-3");
  const [data, setData] = useState("");
  const [testimonialDelay, setTestimonialDelay] = useState(0);
  const [isTheme,setIsTheme]=useState(false);
  const settings = {
    slidesPerView: 1,
    loop: false,
	spaceBetween: 20,
    autoplay: {
     delay: testimonialDelay,
     disableOnInteraction: false
    }
  }

  useEffect(() => {
    if (themeSettingsData && Object.keys(themeSettingsData).length > 0) {
      themeSettingsData.map((i) => {
        if (i.settingsName === "testimonial") {
          setTestimonialId(i._id)
          setData(i.values[0])
          if (i.values[0].bgImage != "" && i.values[0].bgImage != undefined) {
            setBgImage(i.values[0].bgImage);
          } else {
            setBgImage("");
          }
          if (i.values[0].bgColor && i.values[0].bgColor != "" && i.values[0].bgColor != undefined) {
            setBgColor(i.values[0].bgColor)
          } else {
            setBgColor("")
          }
			if (i?.values[0]?.testimonialDelay) {
			 	let second=i?.values[0]?.testimonialDelay.replace(/[^0-9]/g,'')
				let testimonialSec = Number(second) * 1000
				setTestimonialDelay(testimonialSec)
			} else {
				setTestimonialDelay(5000)
			}
        }
      })
	  setIsTheme(true)
    }
  }, [themeSettingsData])

  let bgStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL + bgImage
      })`,
    backgroundColor: bgColor
  }

  let pt = data.paddingTop ? data.paddingTop : "pt-50";
  let pb = data.paddingBottom ? data.paddingBottom : "pb-50";
  let mb = data.marginBottom ? data.marginBottom : "mt-50";
  let mt = data.marginTop ? data.marginTop : "mb-50";
  let mr = data.marginRight ? data.marginRight : "";
  let ml = data.marginLeft ? data.marginLeft : "";
  let pl = data.paddingLeft ? data.paddingLeft : "pl-0";
  let pr = data.paddingRight ? data.paddingRight : "pr-0";
  let fullSection = data.fullSection ? "container-fluid" : "container";

  return (
    <div className={`antera-testimonial-content-container testimonial-area bg-img ${pt} ${pb} ${mb} ${mt} ${mr} ${ml} ${pl} ${pr}`} style={bgStyle} >
      <div className={`antera-testimonial-section-container ${fullSection}`}>
        <div className="edit-inline">
          <TestimonialImageEditIcon testimonialId={testimonialId} fromEditAction="bgImage" />
        </div>
        <div className="row">
          <div className="col-lg-10 ml-auto mr-auto">
            <div className="antera-testimonial-content testimonial-active nav-style-1 nav-testi-style">
              {(!!testimonialDelay && isTheme) && <Swiper {...settings}>
                {testimonialList && Object.keys(testimonialList).length > 0 &&
                  testimonialList.map((single, key) => {
                    return (
                      <TestimonialTwoSingle
                        data={single}
                        key={key}
                        sliderClass="swiper-slide"
                      />
                    );
                  })}
              </Swiper>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TestimonialTwo.propTypes = {
  bgColorClass: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceLeftClass: PropTypes.string,
  spaceRightClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default TestimonialTwo;
